import { columnForField, defaultColumnWidth } from "../../Grid/columnForField";
import { ContactOverviewItem } from "./ContactOverviewItem";

function ContactGridColumns() {
  return [
    columnForField<ContactOverviewItem>("LastName", {
      title: "Last Name",
      width: "200px",
      locked: true,
    }),
    columnForField<ContactOverviewItem>("FirstName", {
      title: "First Name",
      width: "200px",
    }),
    columnForField<ContactOverviewItem>("Gsdb", {
      title: "GSDB",
      width: defaultColumnWidth,
    }),
    columnForField<ContactOverviewItem>("Company", { width: "200px" }),
    columnForField<ContactOverviewItem>("Typ", { title: "Contact Type", width: "200px" }),
    columnForField<ContactOverviewItem>("JobTitle", {
      title: "Job Title",
      width: "250px",
    }),
    columnForField<ContactOverviewItem>("Roles", {
      width: "200px",
    }),
    columnForField<ContactOverviewItem>("Email", {
      title: "E-Mail",
      width: "300px",
    }),
    columnForField<ContactOverviewItem>("BusinessPhone", {
      title: "Business Phone",
      width: "200px",
    }),
    columnForField<ContactOverviewItem>("MobilePhone", {
      title: "Mobile Phone",
      width: "180px",
    }),
    columnForField<ContactOverviewItem>("Notes", {
      width: "300px",
    }),
  ];
}

export default ContactGridColumns;
